import {css} from '@emotion/css';
import {useMemo} from 'react';

// eslint-disable-next-line no-restricted-imports
import {useTheme} from '@veneer/theme';

const useStyle = () => {
    const theme = useTheme();

    const avatarSize = 48;

    // Don't like using # codes, but WEX picked there own color and it's not available in the veneer theme. Would prefer to minimise impact
    // so just keeping it here for now. If we need to use it outside the AppHeader component we can deal with that later.
    //
    // Testing colors is really useful, this should be fine. Theme provider isn't passed in tests so it uses default 'light' but WEX wrapper adds new context that uses dark mode.
    // We can trust veneer to take care of the rest.
    /* istanbul ignore next */
    const wexBorder = theme.mode === 'dark' ? '#585858' : theme.palette.stroke.default;

    return useMemo(
        () => ({
            card: css({
                padding: theme.orbitalFour,
                margin: theme.orbitalFour,
                minWidth: 380,
                maxWidth: 460,
            }),

            cardInner: css({
                display: 'grid',
                gridTemplateColumns: `${avatarSize}px 1fr`,
                gap: theme.orbitalFour,
            }),

            buttonContainers: css({
                display: 'grid',
                gridTemplateColumns: `${avatarSize}px 1fr`,

                '&:not(:last-child)': {
                    paddingBottom: theme.orbitalFour,
                    borderBottom: `1px solid ${wexBorder}`,
                },
                '&:not(:first-child)': {
                    paddingTop: theme.orbitalFour,
                },
            }),

            avatar: css({
                background: theme.palette.neutral.background,
                borderRadius: '50%',
                width: avatarSize,
                height: avatarSize,
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            }),

            username: css({
                marginTop: theme.orbitalOne,
                fontSize: theme.typography.size3,
                lineHeight: theme.typography.lineHeight3,
            }),
            email: css({
                fontSize: theme.typography.size0,
                lineHeight: theme.typography.lineHeight1,
            }),

            icon: {
                width: 60,
                height: 60,
            },

            userEmail: css({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: `${theme.orbitalTwo} 0`,
                marginBottom: theme.orbitalFour,
                lineHeight: theme.typography.lineHeight2,
            }),

            userEmailText: css({
                marginLeft: theme.orbitalTwo,
                lineHeight: theme.typography.lineHeight2,
            }),

            actionsContainer: css({
                marginBottom: theme.orbitalFour,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: theme.orbitalTwo,

                a: {
                    color: theme.palette.primary.default,
                    fontSize: theme.typography.size0,
                    lineHeight: theme.typography.lineHeight1,
                },
            }),

            buttonContainer: css({
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
            }),

            userMenuActions: css({
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                listStyle: 'none',
                justifyContent: 'start',
                gap: theme.orbitalTwo,
                padding: 0,
                margin: `${theme.orbitalOne} 0`,
            }),
        }),
        [
            theme.orbitalFour,
            theme.orbitalOne,
            theme.orbitalTwo,
            theme.palette.neutral.background,
            theme.palette.primary.default,
            theme.typography.lineHeight1,
            theme.typography.lineHeight2,
            theme.typography.lineHeight3,
            theme.typography.size0,
            theme.typography.size3,
            wexBorder,
        ]
    );
};

export default useStyle;
